import Vue from 'vue'
import moment from "moment";

Vue.mixin({
    data() {
      return {
        WS_Host: 'localhost',
      }
    },
    methods: {
      covertime2(value){
        if (value) {
            var t = moment(value).format("DD MMMM YYYY h:mm a")
            return t;
          }
      },
      convertseverity(val) {
        if(val == 1){
          return 'Low'
        }else if(val == 2){
          return 'Modarate'
        }else if(val == 3){
          return 'High'
        }else if(val == 4){
          return 'Critical'
        }
      },
    },
    mounted() {
        // alert(1)
    }
  })
  


// WEBPACK FOOTER //
// ./src/function.js